import { useMutation } from '@tanstack/react-query';

import { ServerSideEventName, tokenRequests } from '../../../api/api';
import { useBookingConfirmPaymentData } from '../../../hooks/useBookingConfirmationMutation';
import { useInvoice } from '../../../hooks/useInvoice';
import { useOnlineBookingReducer } from '../../../state/useOnlineBookingReducer';

type UseServerSideEventsMutationParams = {
  eventName: ServerSideEventName;
};

export const useServerSideEvents = () => {
  const { state } = useOnlineBookingReducer();
  const { token, contactDetails, paymentDetails } = state;
  const paymentData = useBookingConfirmPaymentData();

  const currentDate = new Date().toISOString().split('T')[0] as string;

  const { data: invoiceData } = useInvoice(paymentData?.invoiceToken);

  return useMutation({
    mutationFn: (params: UseServerSideEventsMutationParams) =>
      tokenRequests.sendServerSideEvent({
        eventName: params.eventName,
        token,
        domain: 'Online Booking',
        bookingUuid: paymentData?.bookingUuid,
        email: contactDetails.values.email,
        paymentDate: currentDate,
        outstandingBalance: invoiceData ? invoiceData?.total - invoiceData?.dueAmount || 0 : 0,
        paymentAmount: invoiceData?.amount || 0,
        last4CardNumber: paymentDetails?.last4 || '',
        paymentDescription: invoiceData?.template === 'deposit' ? 'deposit' : 'full upfront payment',
      }),
  });
};
